import "./App.css";
import { useState } from "react";


const NAV = [
  { id: "about", label: "Σχετικα" },
  { id: "approach", label: "Προσεγγιση" },
  { id: "contact", label: "Επικοινωνια" },
];

export default function App() {
  const [privacyOpen, setPrivacyOpen] = useState(false);

  return (
    <div className="page">
      <SkipLink />
      <Header />

      <main id="main" className="main">
        <Hero />
        <SectionAbout />
        <SectionOffice />
        <SectionApproach />
        <SectionContact />
      </main>

      <Footer onPrivacyOpen={() => setPrivacyOpen(true)} />

      {privacyOpen && (
        <PrivacyModal onClose={() => setPrivacyOpen(false)} />
      )}
    </div>
  );
}

function SkipLink() {
  return (
    <a className="skipLink" href="#main">
      Μετάβαση στο περιεχόμενο
    </a>
  );
}

function Header() {
  return (
    <header className="header">
      <div className="container headerInner">
        <div className="brand">
  <img src="/LOGO.png" alt="Όλγα Τρομπούκη" className="brandLogo" />
  <div className="brandText">
    <div className="brandName">Όλγα Τρομπούκη</div>
    <div className="brandSub">Ψυχολόγος MSc. · Ψυχαναλύτρια</div>
  </div>
</div>

        <nav className="nav" aria-label="Κύρια πλοήγηση">
          {NAV.map((item) => (
            <a key={item.id} className="navLink" href={`#${item.id}`}>
              {item.label}
            </a>
          ))}
        </nav>
      </div>
    </header>
  );
}

function Hero() {
  return (
    <section className="hero" aria-label="Εισαγωγή">
      <div className="container heroGrid">
        <div className="heroCopy">
          
        </div>


      </div>
    </section>
  );
}

function SectionAbout() {
  return (
    <section id="about" className="section">
      <div className="container">

        <div className="sectionHead">
          <h2>Όλγα Τρομπούκη</h2>
          <p className="sectionLead">
            Ψυχολόγος MSc. · Ψυχαναλύτρια
          </p>
        </div>

        <div className="grid2 aboutGrid">

          <div className="aboutPhoto">
            <img
              src="/olga.jpg"
              alt="Όλγα Τρομπούκη Ψυχολόγος - Ψυχαναλύτρια"
            />
          </div>

          <div className="card aboutCard">

            <p>
              Η Όλγα Τρομπούκη είναι Ψυχολόγος με άδεια ασκήσεως
              επαγγέλματος <strong>(Αρ. Αδείας 6772)</strong> και διατηρεί
              ιδιωτικό γραφείο στο Παλαιό Φάληρο.
            </p>

            <p>
              Εργάζεται με ενήλικες και εφήβους στην όψιμη εφηβεία,
              με ψυχαναλυτικό προσανατολισμό.
            </p>

            <p>
              Είναι απόφοιτη του Τμήματος Ψυχολογίας του Παντείου
              Πανεπιστημίου και κάτοχος Μεταπτυχιακού Διπλώματος Σπουδών
              της Ιατρικής Σχολής του Εθνικού και Καποδιστριακού
              Πανεπιστημίου Αθηνών.
            </p>

            <details className="expandBlock">
              <summary>Περισσότερα για την εκπαίδευση και την εμπειρία</summary>

              <div className="expandContent">

                <p>
                  Το μεταπτυχιακό της έχει αντικείμενο
                  <em>
                    {" "}
                    «Ψυχοθεραπεία: Θεωρητικά Πλαίσια, Κλινικές Εφαρμογές
                    και Συγκριτικές Προσεγγίσεις».
                  </em>
                </p>

                <p>
                  Η ψυχαναλυτική της κατάρτιση συνδέεται με τον
                  Ψυχαναλυτικό Σύλλογο <em>Φρόυντ</em> <em>Λακάν</em>, του οποίου
                  είναι ενεργό μέλος από το 2020.
                </p>

                <p>
                  Συμμετέχει συστηματικά σε σεμινάρια, εργαστήρια και
                  κλινικές παρουσιάσεις, ενώ η προσωπική ανάλυση και η
                  ψυχαναλυτική εποπτεία αποτελούν σταθερό μέρος της
                  κλινικής της πρακτικής.
                </p>

                <h4>Επαγγελματική εμπειρία</h4>

                <p>
                  Έχει δεκαετή εμπειρία στον χώρο της ψυχοκοινωνικής
                  υποστήριξης από τη συνεργασία της με την Hellas EAP
                  (Employee Assistance Programs).
                </p>

                <p>
                  Στο πλαίσιο αυτό εργάστηκε σε 24ωρη γραμμή
                  συμβουλευτικής και διαχείρισης κρίσεων, παρέχοντας
                  άμεση και εμπιστευτική υποστήριξη σε εργαζομένους
                  και μέλη των οικογενειών τους.
                </p>

                <p>
                  Παράλληλα, ανέλαβε τη διαχείριση περιστατικών ως
                  Case Manager και τον συντονισμό δικτύου συνεργαζόμενων
                  ψυχολόγων ως Affiliate Network Coordinator,
                  συμμετέχοντας σε κλινικές ομάδες, εκπαιδευτικές
                  συναντήσεις και σεμινάρια.
                </p>

                <p>
                  Έχει επίσης πραγματοποιήσει κλινική άσκηση και
                  εθελοντική εργασία στην ΑΜΚΕ IASIS με ευάλωτους
                  πληθυσμούς και έχει συμμετάσχει σε επιστημονικές
                  ημερίδες.
                </p>

                <p>
                  Το 2026 παρουσίασε τη διπλωματική της εργασία στο
                  πλαίσιο του μεταπτυχιακού της προγράμματος στην
                  Ιατρική Σχολή Αθηνών, με θέμα "το Ψυχικό Σύμπτωμα: Θεωρητικές και Κλινικές Προσεγγίσεις από την Ψυχανάλυση, τη Γνωσιακή-Συμπεριφορική και τη Συστηματική Θεραπεία".
                </p>

              </div>
            </details>

          </div>
        </div>

        <div className="quickFactsSection">
          <h3>Σύντομα Στοιχεία</h3>

          <ul className="quickFactsList">
            <li>
              <strong>Άδεια ασκήσεως επαγγέλματος: 6772</strong>
            </li>

            <li>
              <strong>
                Πρακτική άσκηση και εθελοντική εργασία - <em>IASIS</em>
              </strong>
            </li>

            <li>
              <strong>Μεταπτυχιακό: Ψυχοθεραπεία - ΕΚΠΑ</strong>
            </li>

            <li>
              <strong>Πτυχίο: Ψυχολογία - Πάντειο Πανεπιστήμιο</strong>
            </li>

            <li>
              <strong>
                10 έτη εμπειρίας σε Εταιρεία Ψυχοκοινωνικής Υποστήριξης
                <br />
                (24ωρη γραμμή συμβουλευτικής &amp; διαχείρισης κρίσεων, Case Manager, Affiliate Network Coordinator)
              </strong>
            </li>

            <li>
              <strong>
                Μέλος Ψυχαναλυτικού Συλλόγου <em>Φρόυντ - Λακάν</em> (2020-σήμερα)
              </strong>
            </li>


          </ul>
        </div>

      </div>
    </section>
  );
}


function SectionApproach() {
  return (
    <section id="approach" className="section approachSection">
      <div className="container">
        <div className="approachMainBlock">
          <h2>Προσέγγιση</h2>
          <div className="approachText">
            <p>
              Ο θεωρητικός προσανατολισμός και η κλινική πρακτική βασίζονται στην ψυχαναλυτική προσέγγιση της θεραπείας.
            </p>

            <p>
              Η ψυχανάλυση αποτελεί μία πρακτική του λόγου. Το πλαίσιο διασφαλίζει έναν ασφαλή χώρο όπου κάθε άνθρωπος μπορεί να μιλήσει ελεύθερα σε κάποιον που ακούει για ό,τι τον απασχολεί, ό,τι του προκαλεί δυσφορία αλλά και ευρύτερα για όσα έχουν ουσιαστική σημασία στη ζωή του: την προσωπική ιστορία, τις κομβικές στιγμές, τα σημαντικά πρόσωπα. Μέσα από τον λόγο, τις επαναλήψεις, τα όνειρα, τις παραδρομές, τις φαινομενικά παράλογες ή αστείες σκέψεις και πράξεις καθώς και μέσα από το σύμπτωμα, ανοίγεται η δυνατότητα να ακουστεί κάτι από την ιδιαίτερη αλήθεια του κάθε ανθρώπου.
            </p>

            <p>
              Η ψυχαναλυτική διαδικασία μπορεί να συνοδεύσει ανθρώπους που βιώνουν έντονο άγχος, επαναλαμβανόμενα αδιέξοδα, δυσκολίες στις σχέσεις τους, τη σεξουαλικότητά τους, την εργασία, κρίσεις ή την επίμονη αίσθηση ότι «κάτι δε λειτουργεί». Πρόκειται για μια απαιτητική αλλά βαθιά δημιουργική εργασία, η οποία δύναται να οδηγήσει σε έναν διαφορετικό τρόπο ύπαρξης με περισσότερη ελευθερία, επιθυμία και προσωπική ευθύνη απέναντι στον εαυτό και στη ζωή.
            </p>

            <p>
              Μακριά από έτοιμες, προκαθορισμένες κρίσεις ή συμβουλές, πραγματοποιείται μια βαθιά επεξεργασία όσων στέκονται εμπόδιο απέναντι σε μια πιο πλούσια, δημιουργική και ικανοποιητική ζωή και καθίσταται δυνατή μια διαφορετική σχέση με όσα μέχρι τώρα λειτουργούν ως αδιέξοδο.
            </p>

            <p>
              Η κλινική κατάρτιση πλαισιώνεται από τις αρχές που έθεσαν ο Σίγκμουντ Φρόυντ και ο Ζακ Λακάν, ψυχαναλυτές των οποίων το έργο πάνω στα ζητήματα του ψυχισμού διαμόρφωσε μια νέα οπτική στον τρόπο που προσεγγίζουμε την ψυχική υγεία ενώ η προσωπική ανάλυση και η ψυχαναλυτική εποπτεία συνεχίζουν να αποτελούν αναπόσπαστο μέρος της κλινικής πρακτικής.
            </p>
          </div>
        </div>


        <div className="processBlock">
          <div className="sectionHead">
            <h2>Για τη διαδικασία…</h2>
          </div>

          <div className="approachText">
            <p>
              Η διεξαγωγή των συνεδριών, η πορεία, τα ορόσημα και το τέλος της ανάλυσης διαφέρουν για κάθε άτομο.
            </p>

            <p>
              Η απόφαση να ξεκινήσει κανείς μια ψυχαναλυτική διαδικασία συνοδεύεται συχνά από αμφιθυμία. Η επιθυμία για σταθερότητα -ακόμη κι όταν αυτή συνδέεται με κάτι που προκαλεί δυσφορία- μπορεί να συνυπάρχει με την επιθυμία για αλλαγή ή ακόμη και να την υπερνικά. Το κίνητρο σπάνια είναι απολύτως σαφές από την αρχή· ωστόσο, ακριβώς αυτή η επιθυμία να μιλήσει κανείς και να διερευνήσει ό,τι τον φέρνει στην ανάλυση αποτελεί την αφετηρία της αναλυτικής εργασίας.
            </p>
          </div>

          <div className="statementCard">
            «Οι συνεδρίες γίνονται δια ζώσης, εφόσον είναι εφικτό, πράγμα σημαντικό στην εποχή του διαδικτύου αλλά γίνονται προσαρμογές όπου και όταν είναι απαραίτητο».
          </div>
        </div>


        <div className="quoteCard">
          <p className="quote">
            «Ένα λέγειν είναι της τάξεως του συμβάντος»
            <br />
            <span>«Un dire est de l'ordre de l'événement»</span>
            <br />
            <small>— Ζακ Λακάν, Les non-dupes errent (1973–74)</small>
            
          </p>
      <p>  </p>
        </div>


        <div className="sectionHead symptomTitle">
          <br />
          <h2>Σύμπτωμα</h2>
        </div>

        <div className="approachText">
          <p>
            Στην ψυχανάλυση, η εργασία ξεκινά από αυτό ακριβώς που δε λειτουργεί για το υποκείμενο: το σύμπτωμά του. Το ζητούμενο δεν είναι η άμεση εξάλειψή του αλλά η διερεύνηση της θέσης που κατέχει στην ιστορία και στη ζωή του κάθε ανθρώπου.
          </p>

          <p>
            Το ίδιο σύμπτωμα μπορεί να έχει εντελώς διαφορετική σημασία για δύο διαφορετικούς ανθρώπους. Γι' αυτό και στην ψυχανάλυση δεν αναζητείται ένα καθολικό νόημα αλλά ο ιδιαίτερος τρόπος με τον οποίο το κάθε υποκείμενο βιώνει τη δυσφορία του και μιλά γι' αυτήν. Το σύμπτωμα δεν αποκόπτεται από την προσωπική ιστορία ούτε από την εποχή μέσα στην οποία εμφανίζεται. Επηρεάζεται από τις κοινωνικές και πολιτισμικές συνθήκες αλλά παραμένει πάντοτε μοναδικό ως προς τον τρόπο με τον οποίο εγγράφεται στην ιστορία του κάθε ανθρώπου.
          </p>

          <p>
            Από αυτήν την οπτική, το σύμπτωμα δεν αντιμετωπίζεται ως μια δυσλειτουργία που πρέπει απλώς να διορθωθεί ούτε ως ένα σύνολο χαρακτηριστικών που αρκεί να ταξινομηθούν σε μια διαγνωστική κατηγορία. Η ψυχαναλυτική εργασία ενδιαφέρεται πρωτίστως να κατανοήσει τι σημαίνει το σύμπτωμα καθώς αυτό μπορεί να αποτελεί μήνυμα που μιλά για επιθυμίες, συγκρούσεις, πόνο που πηγάζει από μια προσωπική ιστορία, η οποία μερικές φορές μπορεί να ζωντανέψει μόνο όταν εκφράζεται σε έναν ενεργό ακροατή.
          </p>
        </div>

        <div className="statementCard">
          Η ψυχανάλυση επαναφέρει το σύμπτωμα στο κέντρο της ανθρώπινης εμπειρίας, όχι ως κάτι που πρέπει να σιωπήσει αλλά ως κάτι που μπορεί να ακουστεί.
        </div>


        <details className="expandBlock theoryBlock">
          <summary>Από τον Φρόυντ στον Λακάν</summary>

          <div className="expandContent">
            <p>
              Για τον Σίγκμουντ Φρόυντ, το σύμπτωμα αποτελεί αποτέλεσμα της απώθησης κι έναν τρόπο με τον οποίο ο ψυχισμός επιχειρεί να διαχειριστεί τις εσωτερικές του συγκρούσεις. Όπως και το όνειρο διαθέτει ερμηνευτική διάσταση· μέσα από αυτό εκφράζονται με συμβολικό τρόπο επιθυμίες, συγκρούσεις και μνήμες που δε μπορούν να γίνουν άμεσα συνειδητές. Το σύμπτωμα μπορεί να μοιάζει παράλογο ή ανεπιθύμητο όμως για τον Φρόυντ είναι πάντοτε φορέας νοήματος και γι' αυτό ζητά ερμηνεία και όχι μόνο διάγνωση.
            </p>

            <p>
              Ο Ζακ Λακάν, συνεχίζοντας τη φροϋδική σκέψη, έδωσε ακόμη μεγαλύτερη έμφαση στη μοναδικότητα του συμπτώματος. Το σύμπτωμα δεν έχει μια γενική σημασία που ισχύει για όλους· συνδέεται με την ιδιαίτερη ιστορία του κάθε υποκειμένου και με τον τρόπο που αυτό κατοικεί τη γλώσσα και οργανώνει την επιθυμία του. Στο ύστερο έργο του ο Λακάν συνδέει το σύμπτωμα με την έννοια της jouissance (απόλαυσης) αναδεικνύοντάς το όχι μόνο ως φορέα νοήματος αλλά και ως έναν ιδιαίτερο τρόπο με τον οποίο το υποκείμενο σχετίζεται με τον εαυτό του και τον κόσμο.
            </p>

            <p>
              Η ψυχαναλυτική εργασία δεν επιδιώκει να αφαιρέσει βιαστικά το σύμπτωμα αλλά να επιτρέψει στο υποκείμενο να διαμορφώσει μια διαφορετική σχέση μαζί του. Μέσα από αυτήν τη διαδικασία μπορεί να αναδυθεί μια νέα κατανόηση της προσωπικής του ιστορίας και ένας διαφορετικός τρόπος να τοποθετηθεί απέναντι σε όσα μέχρι τώρα επιστρέφουν ως δυσφορία ή αδιέξοδο.
            </p>
          </div>
        </details>

      </div>
    </section>
  );
}

function SectionContact() {
  const phoneRaw = "6979571445";
  const phoneTel = "+306979571445";
  const email = "olgatrompouki.psy@gmail.com";
  const addressLabel = "Εσπέρου 45, Π. Φάληρο";

  const mapsQuery = encodeURIComponent(addressLabel);
  const mapsLink = `https://www.google.com/maps/search/?api=1&query=${mapsQuery}`;

  return (
    <section id="contact" className="section sectionAlt">
      <div className="container">
        <div className="sectionHead">
          <h2>Επικοινωνία</h2>
          <p>
            Μπορείτε να καλέσετε, να στείλετε email ή να ανοίξετε τη
            διεύθυνση στον χάρτη.
          </p>
        </div>

        <div className="card contactCard">
          <h3>Στοιχεία</h3>

          <ul className="list">
            <li>
              <span className="liKey">Τηλεφωνο</span>

              <a
                className="liVal liValLink"
                href={`tel:${phoneTel}`}
              >
                (+30) {phoneRaw}
              </a>
            </li>

            <li>
              <span className="liKey">Email</span>

              <a
                className="liVal liValLink"
                href={`mailto:${email}`}
              >
                {email}
              </a>
            </li>

            <li>
              <span className="liKey">Διευθυνση</span>

              <a
                className="liVal liValLink"
                href={mapsLink}
                target="_blank"
                rel="noreferrer"
              >
                {addressLabel}
              </a>
            </li>

            <li>
              <span className="liKey">Ωρες</span>

              <span className="liVal">
                Κατόπιν ραντεβού
              </span>
            </li>
          </ul>

          <div className="divider" />

          <p className="smallMuted">
            Σε επείγουσα ανάγκη ή κίνδυνο, καλέστε το 112 ή
            απευθυνθείτε σε εφημερεύον νοσοκομείο.
          </p>
        </div>
      </div>
    </section>
  );
}


function Footer({ onPrivacyOpen }) {
  return (
    <footer className="footer" aria-label="Υποσέλιδο">
      <div className="container footerInner">
        <div className="footLeft">
          <div className="brandMini">
            <span className="brandMark sm" aria-hidden="true" />
            <span>Όλγα Τρομπούκη</span>
          </div>

          <div className="smallMuted">
            © {new Date().getFullYear()} • Ψυχολόγος MSc. • Ψυχαναλύτρια
          </div>
        </div>

        <div className="footRight">
          <a className="footLink" href="#about">
            Σχετικα
          </a>

          <a className="footLink" href="#contact">
            Επικοινωνια
          </a>

          <span className="footSep" aria-hidden="true">
            •
          </span>

          <button
            type="button"
            className="footLink privacyButton"
            onClick={onPrivacyOpen}
          >
            Πολιτικη Απορρητου
          </button>
        </div>
      </div>
      <div className="imageCredits">
  Image credits: NASA/ESA, G. Schneider — Public Domain
  <span aria-hidden="true"> · </span>
  Edvard Munch, <em>Encounter in Space</em> — Public Domain artwork
</div>
    </footer>
  );
}

function PrivacyModal({ onClose }) {
  return (
    <div className="privacyOverlay" onClick={onClose}>
      <div
        className="privacyModal"
        role="dialog"
        aria-modal="true"
        aria-labelledby="privacy-title"
        onClick={(e) => e.stopPropagation()}
      >
        <button
          type="button"
          className="privacyClose"
          onClick={onClose}
          aria-label="Κλείσιμο Πολιτικής Απορρήτου"
        >
          ×
        </button>

        <div className="privacyContent">
          <h2 id="privacy-title">Πολιτική Απορρήτου</h2>

          <p>
            Η προστασία της ιδιωτικότητας και των προσωπικών δεδομένων
            των επισκεπτών της ιστοσελίδας{" "}
            <strong>olgatrompouki.com</strong> αποτελεί σημαντική
            προτεραιότητα.
          </p>

          <p>
            Η παρούσα Πολιτική Απορρήτου εξηγεί ποια προσωπικά δεδομένα
            ενδέχεται να υποβάλλονται σε επεξεργασία κατά την επίσκεψη
            στην ιστοσελίδα ή κατά την επικοινωνία μέσω των στοιχείων που
            παρέχονται σε αυτήν, για ποιους σκοπούς χρησιμοποιούνται και
            ποια δικαιώματα έχουν τα υποκείμενα των δεδομένων.
          </p>

          <p>
            Η παρούσα ενημέρωση αφορά τη λειτουργία της ιστοσελίδας και
            την αρχική επικοινωνία μέσω αυτής. Τυχόν επεξεργασία
            προσωπικών δεδομένων στο πλαίσιο επαγγελματικής ή
            θεραπευτικής σχέσης μπορεί να διέπεται και από ειδικότερη
            ενημέρωση και από τις σχετικές νόμιμες και επαγγελματικές
            υποχρεώσεις.
          </p>

          <h3>1. Υπεύθυνη επεξεργασίας</h3>

          <p>
            Υπεύθυνη για την επεξεργασία των προσωπικών δεδομένων είναι:
          </p>

          <p>
            <strong>Όλγα Τρομπούκη</strong>
            <br />
            Ψυχολόγος MSc. – Ψυχαναλύτρια
            <br />
            Email:{" "}
            <a href="mailto:olgatrompouki.psy@gmail.com">
              olgatrompouki.psy@gmail.com
            </a>
          </p>

          <h3>2. Δεδομένα που συλλέγονται μέσω της ιστοσελίδας</h3>

          <p>
            Η ιστοσελίδα έχει κατά κύριο λόγο ενημερωτικό χαρακτήρα.
          </p>

          <p>
            Δεν διαθέτει φόρμα επικοινωνίας, δυνατότητα δημιουργίας
            λογαριασμού, εγγραφή σε newsletter ή σύστημα ηλεκτρονικών
            συναλλαγών.
          </p>

          <p>
            Δεν χρησιμοποιούνται εργαλεία διαφημιστικής παρακολούθησης ή
            ανάλυσης της συμπεριφοράς των επισκεπτών, όπως Google
            Analytics ή Meta Pixel.
          </p>

          <p>
            Κατά την απλή επίσκεψη στην ιστοσελίδα ενδέχεται να
            καταγράφονται αυτόματα από την τεχνική υποδομή ή τον πάροχο
            φιλοξενίας ορισμένα δεδομένα που είναι αναγκαία για τη
            λειτουργία και την ασφάλειά της, όπως ενδεικτικά:
          </p>

          <ul>
            <li>η διεύθυνση IP,</li>
            <li>ο τύπος και η έκδοση του προγράμματος περιήγησης,</li>
            <li>ο τύπος συσκευής ή λειτουργικού συστήματος,</li>
            <li>η ημερομηνία και η ώρα πρόσβασης,</li>
            <li>
              τεχνικά αρχεία καταγραφής και πληροφορίες σχετικά με
              σφάλματα ή ζητήματα ασφάλειας.
            </li>
          </ul>

          <p>
            Τα δεδομένα αυτά χρησιμοποιούνται αποκλειστικά για την
            τεχνική λειτουργία, την ασφάλεια, την πρόληψη κακόβουλης
            χρήσης και την προστασία της ιστοσελίδας.
          </p>

          <h3>3. Επικοινωνία μέσω email ή τηλεφώνου</h3>

          <p>
            Η ιστοσελίδα παρέχει στοιχεία τηλεφωνικής και ηλεκτρονικής
            επικοινωνίας.
          </p>

          <p>
            Όταν κάποιος επιλέγει να επικοινωνήσει μέσω email ή
            τηλεφώνου, ενδέχεται να υποβληθούν σε επεξεργασία στοιχεία
            όπως το ονοματεπώνυμο, τα στοιχεία επικοινωνίας και
            οποιαδήποτε άλλη πληροφορία ο ίδιος επιλέξει να
            γνωστοποιήσει.
          </p>

          <p>Οι πληροφορίες αυτές χρησιμοποιούνται αποκλειστικά για:</p>

          <ul>
            <li>την απάντηση στο αίτημα επικοινωνίας,</li>
            <li>την παροχή των πληροφοριών που ζητήθηκαν,</li>
            <li>
              τη συνεννόηση σχετικά με πιθανή συνεδρία ή ραντεβού,
            </li>
            <li>
              τη διαχείριση της περαιτέρω επικοινωνίας, όπου αυτή
              απαιτείται.
            </li>
          </ul>

          <p>
            Δεν χρησιμοποιούνται για διαφημιστικούς σκοπούς ή για
            αποστολή μη ζητηθείσας εμπορικής επικοινωνίας.
          </p>

          <p>
            Λόγω της φύσης των παρεχόμενων υπηρεσιών, ένα μήνυμα μπορεί
            να περιλαμβάνει πληροφορίες σχετικές με την ψυχική ή
            σωματική υγεία. Συνιστάται, κατά την αρχική επικοινωνία μέσω
            απλού email, να μην αποστέλλονται περισσότερες ευαίσθητες ή
            προσωπικές πληροφορίες από όσες είναι απολύτως απαραίτητες
            για τον σκοπό της επικοινωνίας.
          </p>

          <h3>4. Δεδομένα υγείας και εμπιστευτικότητα</h3>

          <p>
            Τα δεδομένα που αφορούν τη σωματική ή ψυχική υγεία
            αποτελούν ειδική κατηγορία προσωπικών δεδομένων και
            υπόκεινται σε αυξημένη προστασία.
          </p>

          <p>
            Εφόσον στο πλαίσιο μιας επικοινωνίας γνωστοποιηθούν τέτοιες
            πληροφορίες, η επεξεργασία τους πραγματοποιείται μόνο στον
            βαθμό που είναι απαραίτητη και εφόσον συντρέχει η κατάλληλη
            νόμιμη προϋπόθεση σύμφωνα με την ισχύουσα νομοθεσία περί
            προστασίας προσωπικών δεδομένων.
          </p>

          <p>
            Οι πληροφορίες που σχετίζονται με την παροχή υπηρεσιών
            ψυχικής υγείας αντιμετωπίζονται με ιδιαίτερη εμπιστευτικότητα
            και σύμφωνα με τις υποχρεώσεις επαγγελματικού απορρήτου που
            εφαρμόζονται στην εκάστοτε περίπτωση.
          </p>

          <h3>5. Σκοποί και νομική βάση της επεξεργασίας</h3>

          <p>
            Η επεξεργασία προσωπικών δεδομένων πραγματοποιείται μόνο
            όταν υπάρχει νόμιμη βάση και για συγκεκριμένο σκοπό.
          </p>

          <p>
            Ανάλογα με την περίπτωση, η επεξεργασία μπορεί να είναι
            αναγκαία:
          </p>

          <ul>
            <li>
              για την ανταπόκριση σε αίτημα επικοινωνίας ή για τη λήψη
              μέτρων κατόπιν αιτήματος του ενδιαφερομένου πριν από την
              παροχή υπηρεσιών,
            </li>

            <li>
              για την εκπλήρωση νόμιμων ή επαγγελματικών υποχρεώσεων,
            </li>

            <li>
              για την προστασία της ασφάλειας, της ακεραιότητας και της
              ορθής λειτουργίας της ιστοσελίδας,
            </li>

            <li>
              βάσει συγκατάθεσης, όπου αυτή αποτελεί την κατάλληλη
              νομική βάση,
            </li>

            <li>
              καθώς και, στην περίπτωση ειδικών κατηγοριών δεδομένων,
              μόνο όταν συντρέχει μία από τις ειδικές προϋποθέσεις που
              προβλέπει η ισχύουσα νομοθεσία.
            </li>
          </ul>

          <p>
            Δεν πραγματοποιείται αυτοματοποιημένη λήψη αποφάσεων ούτε
            κατάρτιση προφίλ των επισκεπτών της ιστοσελίδας.
          </p>

          <h3>6. Cookies και τεχνολογίες παρακολούθησης</h3>

          <p>
            Με βάση την τρέχουσα λειτουργία της, η ιστοσελίδα δεν
            χρησιμοποιεί cookies για διαφημιστικούς σκοπούς, profiling,
            συμπεριφορική παρακολούθηση ή ανάλυση επισκεψιμότητας μέσω
            υπηρεσιών όπως το Google Analytics.
          </p>

          <p>
            Είναι πιθανό η τεχνική υποδομή ή ο πάροχος φιλοξενίας να
            χρησιμοποιεί απολύτως απαραίτητες τεχνολογίες ή cookies,
            αποκλειστικά όταν αυτά απαιτούνται για την ασφαλή και ορθή
            λειτουργία της ιστοσελίδας.
          </p>

          <p>
            Εάν στο μέλλον προστεθούν προαιρετικές υπηρεσίες ή
            τεχνολογίες που απαιτούν συγκατάθεση, η παρούσα Πολιτική θα
            ενημερωθεί και, όπου απαιτείται, θα παρέχεται στον επισκέπτη
            η δυνατότητα να επιλέξει εάν τις αποδέχεται.
          </p>

          <h3>7. Εξωτερικοί σύνδεσμοι</h3>

          <p>
            Η ιστοσελίδα μπορεί να περιλαμβάνει συνδέσμους προς
            ιστοσελίδες ή υπηρεσίες τρίτων, όπως σύνδεσμο προς το Google
            Maps για την προβολή της διεύθυνσης του γραφείου.
          </p>

          <p>
            Οι υπηρεσίες αυτές δεν φορτώνονται ενσωματωμένες στην
            ιστοσελίδα. Η μετάβαση σε αυτές πραγματοποιείται μόνο εφόσον
            ο επισκέπτης επιλέξει τον αντίστοιχο εξωτερικό σύνδεσμο.
          </p>

          <p>
            Από τη στιγμή που ο επισκέπτης μεταβεί σε ιστοσελίδα τρίτου
            παρόχου, εφαρμόζονται οι όροι και η πολιτική απορρήτου του
            συγκεκριμένου παρόχου.
          </p>

          <h3>8. Αποδέκτες και πάροχοι υπηρεσιών</h3>

          <p>
            Τα προσωπικά δεδομένα δεν πωλούνται, δεν ενοικιάζονται και
            δεν διατίθενται εμπορικά σε τρίτους.
          </p>

          <p>
            Πρόσβαση σε περιορισμένα προσωπικά ή τεχνικά δεδομένα
            ενδέχεται να έχουν, μόνο στον βαθμό που αυτό είναι αναγκαίο
            για την παροχή των υπηρεσιών τους:
          </p>

          <ul>
            <li>ο πάροχος φιλοξενίας της ιστοσελίδας,</li>
            <li>
              τεχνικοί πάροχοι που είναι απαραίτητοι για τη λειτουργία ή
              την ασφάλεια της ιστοσελίδας,
            </li>
            <li>ο πάροχος υπηρεσιών ηλεκτρονικού ταχυδρομείου,</li>
            <li>
              άλλοι συνεργάτες ή πάροχοι, μόνο όταν αυτό είναι
              απαραίτητο και επιτρέπεται από τη νομοθεσία.
            </li>
          </ul>

          <p>
            Προσωπικά δεδομένα μπορεί επίσης να γνωστοποιηθούν όταν αυτό
            επιβάλλεται από τον νόμο, δικαστική απόφαση ή νόμιμο αίτημα
            αρμόδιας δημόσιας αρχής.
          </p>

          <p>
            Εάν η χρήση συγκεκριμένου παρόχου συνεπάγεται διαβίβαση
            προσωπικών δεδομένων εκτός Ευρωπαϊκού Οικονομικού Χώρου, η
            διαβίβαση πραγματοποιείται, όπου απαιτείται, σύμφωνα με τους
            μηχανισμούς και τις εγγυήσεις που προβλέπει η ισχύουσα
            νομοθεσία.
          </p>

          <h3>9. Χρόνος διατήρησης</h3>

          <p>
            Τα προσωπικά δεδομένα δεν διατηρούνται για χρονικό διάστημα
            μεγαλύτερο από αυτό που είναι αναγκαίο για τον σκοπό για τον
            οποίο συλλέχθηκαν.
          </p>

          <p>
            Τα δεδομένα που παρέχονται κατά την αρχική επικοινωνία
            διατηρούνται για όσο απαιτείται για τη διαχείριση του
            σχετικού αιτήματος και, όπου είναι αναγκαίο, για την
            εκπλήρωση νόμιμων ή επαγγελματικών υποχρεώσεων ή για τη
            θεμελίωση, άσκηση ή υποστήριξη νόμιμων αξιώσεων.
          </p>

          <p>
            Εφόσον μετά την αρχική επικοινωνία δημιουργηθεί
            επαγγελματική ή θεραπευτική σχέση, η διατήρηση των σχετικών
            δεδομένων μπορεί να διέπεται από διαφορετικές νόμιμες και
            επαγγελματικές υποχρεώσεις.
          </p>

          <p>
            Τα τεχνικά αρχεία καταγραφής της ιστοσελίδας διατηρούνται
            σύμφωνα με τις αναγκαίες ρυθμίσεις ασφαλείας και τις
            πολιτικές της αντίστοιχης τεχνικής υποδομής ή του παρόχου
            φιλοξενίας.
          </p>

          <h3>10. Ασφάλεια των δεδομένων</h3>

          <p>
            Λαμβάνονται κατάλληλα τεχνικά και οργανωτικά μέτρα με σκοπό
            την προστασία των προσωπικών δεδομένων από μη εξουσιοδοτημένη
            πρόσβαση, απώλεια, αλλοίωση, γνωστοποίηση ή άλλη μη
            επιτρεπτή επεξεργασία.
          </p>

          <p>
            Παρά τα μέτρα προστασίας που εφαρμόζονται, καμία μέθοδος
            ηλεκτρονικής μετάδοσης ή αποθήκευσης δεδομένων δεν μπορεί να
            θεωρηθεί απολύτως ασφαλής.
          </p>

          <p>
            Για τον λόγο αυτό, ειδικά κατά την επικοινωνία μέσω απλού
            email, συνιστάται να περιορίζονται οι ιδιαίτερα ευαίσθητες
            πληροφορίες σε όσες είναι απαραίτητες για την αρχική
            επικοινωνία.
          </p>

          <h3>11. Δικαιώματα σχετικά με τα προσωπικά δεδομένα</h3>

          <p>
            Σύμφωνα με τον Γενικό Κανονισμό για την Προστασία Δεδομένων
            και την ισχύουσα νομοθεσία, κάθε υποκείμενο δεδομένων μπορεί,
            εφόσον συντρέχουν οι νόμιμες προϋποθέσεις, να ασκήσει τα
            ακόλουθα δικαιώματα:
          </p>

          <ul>
            <li>
              <strong>Δικαίωμα πρόσβασης</strong>, ώστε να ενημερωθεί εάν
              και ποια προσωπικά δεδομένα που το αφορούν υποβάλλονται σε
              επεξεργασία.
            </li>

            <li>
              <strong>Δικαίωμα διόρθωσης</strong> ανακριβών ή ελλιπών
              δεδομένων.
            </li>

            <li>
              <strong>Δικαίωμα διαγραφής</strong>, όταν πληρούνται οι
              σχετικές νόμιμες προϋποθέσεις.
            </li>

            <li>
              <strong>Δικαίωμα περιορισμού της επεξεργασίας.</strong>
            </li>

            <li>
              <strong>Δικαίωμα εναντίωσης</strong> στην επεξεργασία, όπου
              αυτό προβλέπεται.
            </li>

            <li>
              <strong>Δικαίωμα φορητότητας</strong>, όπου εφαρμόζεται.
            </li>

            <li>
              <strong>Δικαίωμα ανάκλησης συγκατάθεσης</strong>, όταν η
              επεξεργασία βασίζεται σε συγκατάθεση, χωρίς να θίγεται η
              νομιμότητα της επεξεργασίας που πραγματοποιήθηκε πριν από
              την ανάκλησή της.
            </li>
          </ul>

          <p>
            Για την άσκηση των παραπάνω δικαιωμάτων ή για οποιοδήποτε
            ερώτημα σχετικά με την επεξεργασία προσωπικών δεδομένων,
            μπορεί να γίνει επικοινωνία στη διεύθυνση:
          </p>

          <p>
            <a href="mailto:olgatrompouki.psy@gmail.com">
              <strong>olgatrompouki.psy@gmail.com</strong>
            </a>
          </p>

          <p>
            Για την προστασία των δεδομένων, ενδέχεται να ζητηθούν οι
            απολύτως αναγκαίες πληροφορίες για την επιβεβαίωση της
            ταυτότητας του αιτούντος πριν από την ικανοποίηση ενός
            αιτήματος.
          </p>

          <h3>12. Δικαίωμα υποβολής καταγγελίας</h3>

          <p>
            Εάν κάποιος θεωρεί ότι η επεξεργασία των προσωπικών του
            δεδομένων παραβιάζει την ισχύουσα νομοθεσία, έχει δικαίωμα
            να υποβάλει καταγγελία στην αρμόδια εποπτική αρχή:
          </p>

          <p>
            <strong>
              Αρχή Προστασίας Δεδομένων Προσωπικού Χαρακτήρα
            </strong>
            <br />
            <a
              href="https://www.dpa.gr/"
              target="_blank"
              rel="noreferrer"
            >
              www.dpa.gr
            </a>
          </p>

          <p>
            Η δυνατότητα υποβολής καταγγελίας δεν επηρεάζει οποιοδήποτε
            άλλο διοικητικό ή δικαστικό μέσο προστασίας προβλέπεται από
            τη νομοθεσία.
          </p>

          <h3>13. Αλλαγές στην Πολιτική Απορρήτου</h3>

          <p>
            Η παρούσα Πολιτική Απορρήτου μπορεί να τροποποιείται όταν
            αλλάζει ο τρόπος λειτουργίας της ιστοσελίδας, οι
            χρησιμοποιούμενες τεχνολογίες, οι υπηρεσίες τρίτων ή το
            σχετικό νομικό πλαίσιο.
          </p>

          <p>
            Η εκάστοτε ισχύουσα έκδοση θα είναι διαθέσιμη μέσω της
            ιστοσελίδας.
          </p>

          <p className="privacyUpdated">
            <strong>Τελευταία ενημέρωση: 14 Σεπτεμβρίου 2026</strong>
          </p>

          <button
            type="button"
            className="privacyBottomClose"
            onClick={onClose}
          >
            Κλείσιμο
          </button>
        </div>
      </div>
    </div>
  );
}

function SectionOffice() {
  const photos = [
    "/office1.jpg",
    "/office2.jpeg",
  ];

  const [activeIndex, setActiveIndex] = useState(null);
  const [touchStart, setTouchStart] = useState(null);
  const [touchEnd, setTouchEnd] = useState(null);

  const minSwipeDistance = 50;

  const closeLightbox = () => setActiveIndex(null);

  const goPrev = (e) => {
    if (e) e.stopPropagation();
    setActiveIndex((prev) => (prev === 0 ? photos.length - 1 : prev - 1));
  };

  const goNext = (e) => {
    if (e) e.stopPropagation();
    setActiveIndex((prev) => (prev === photos.length - 1 ? 0 : prev + 1));
  };

  const onTouchStart = (e) => {
    setTouchEnd(null);
    setTouchStart(e.targetTouches[0].clientX);
  };

  const onTouchMove = (e) => {
    setTouchEnd(e.targetTouches[0].clientX);
  };

  const onTouchEnd = () => {
    if (touchStart == null || touchEnd == null) return;

    const distance = touchStart - touchEnd;

    if (distance > minSwipeDistance) goNext();
    if (distance < -minSwipeDistance) goPrev();
  };

  return (
    <section className="section">
      <div className="container">
        <div className="sectionHead">
        </div>

        <div className="officeGrid">
          {photos.map((src, i) => (
            <button
              key={i}
              type="button"
              className="officeThumb"
              onClick={() => setActiveIndex(i)}
              aria-label={`Άνοιγμα φωτογραφίας χώρου ${i + 1}`}
            >
              <img
                src={src}
                alt={`Χώρος συνεδρίας ${i + 1}`}
                className="officeImg"
              />
            </button>
          ))}
        </div>

        {activeIndex !== null && (
          <div className="lightbox" onClick={closeLightbox}>
            <button
              type="button"
              className="lightboxClose"
              onClick={(e) => {
                e.stopPropagation();
                closeLightbox();
              }}
              aria-label="Κλείσιμο"
            >
              ×
            </button>

            <button
              type="button"
              className="lightboxArrow lightboxArrowLeft"
              onClick={goPrev}
              aria-label="Προηγούμενη φωτογραφία"
            >
              ‹
            </button>

            <div
              className="lightboxStage"
              onClick={(e) => e.stopPropagation()}
              onTouchStart={onTouchStart}
              onTouchMove={onTouchMove}
              onTouchEnd={onTouchEnd}
            >
              <img
                src={photos[activeIndex]}
                alt={`Χώρος συνεδρίας ${activeIndex + 1}`}
                className="lightboxImage"
              />
            </div>

            <button
              type="button"
              className="lightboxArrow lightboxArrowRight"
              onClick={goNext}
              aria-label="Επόμενη φωτογραφία"
            >
              ›
            </button>
          </div>
        )}
      </div>
    </section>
  );
}